import { BaseCheckbox } from 'shared/ui/Checkbox';
import type { Option } from 'shared/ui/MultiSelect/interfaces';
import style from 'shared/ui/MultiSelect/Components/Menu.module.scss';

interface SelectAllProps<T extends Option> {
  options: T[];
  selectedOptions: T[];
  handleSelect: (value: T[], e: React.MouseEvent<HTMLLIElement>) => void;
  withoutCheckbox?: boolean;
}

export function SelectAll<T extends Option>({
  options,
  selectedOptions,
  handleSelect,
  withoutCheckbox,
}: SelectAllProps<T>) {
  const hasValues = selectedOptions.some((option) => options.some((selectedOption) => selectedOption.id === option.id));

  const allSelected = options.every((option) =>
    selectedOptions.some((selectedOption) => selectedOption.id === option.id)
  );
  const someSelected = hasValues && !allSelected;
  const leftOptions = selectedOptions.filter((option) => !options.some((selected) => selected.id === option.id));

  return (
    <li
      className={style.option}
      onClick={(e) => {
        handleSelect(allSelected ? leftOptions : options, e);
      }}
    >
      <span className="pointer-events-none flex items-center justify-start">
        {!withoutCheckbox && (
          <span className="flex">
            <BaseCheckbox
              isChecked={someSelected || allSelected}
              isPartial={someSelected}
            />
          </span>
        )}
        <span className="ml-1 font-medium">Select all</span>
      </span>
    </li>
  );
}
